import React, { useEffect } from "react";
import {
  Box,
  Pagination,
  Stack,
  Typography,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import { useDispatch } from "react-redux";

const PaginationComponent = ({
  api,
  meta,
  loading,
  otherProps,
  onLimitChange,
  dependencyFields = [],
}) => {
  const dispatch = useDispatch();
  const { totalRecords = 0, totalPages = 1, currentPage = 1 } = meta || {};

  const [page, setPage] = React.useState(currentPage || 1);
  const [limit, setLimit] = React.useState(meta?.limit || 25);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  useEffect(() => {
    const data = {
      page: page,
      limit: limit,
      ...otherProps,
    };

    dispatch(api(data));
  }, [page, limit, otherProps?.user?.userID, ...dependencyFields]);

  const handleLimitChange = (event) => {
    const newLimit = event.target.value;
    setLimit(newLimit);
    if (onLimitChange) {
      onLimitChange(newLimit);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 2,
        py: 0.5,
        px: 1,
      }}
    >
      <Box
        sx={{
          minWidth: 60,
          height: 32,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "0.75rem",
          border: "1px solid rgba(0, 0, 0, 0.23)",
          borderRadius: 1,
          px: 1.5,
        }}
      >
        Total Records : {totalRecords}
      </Box>
      <Box>
        <Pagination
          count={totalPages}
          page={page}
          onChange={handlePageChange}
          size="small"
          siblingCount={1}
          boundaryCount={0}
        />
      </Box>

      <Box>
        <FormControl
          size="small"
          sx={{
            minWidth: 60,
            "& .MuiInputBase-root": {
              height: 32, // Small, but not too small
              fontSize: "0.75rem", // Around 12px
            },
            "& .MuiInputLabel-root": {
              fontSize: "0.75rem",
            },
          }}
        >
          <InputLabel id="limit-label">Limit</InputLabel>
          <Select
            labelId="limit-label"
            id="limit-select"
            value={limit}
            label="Limit"
            onChange={handleLimitChange}
          >
            {" "}
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

export default PaginationComponent;
